import DockButton from '~/components/DockButton'
import DockShareLink from '~/components/DockShareLink'
import Flex from '~/components/Flex'
import ListLoader from '~/components/ListLoader'

export default function DockStateLoading() {
  return (
    <>
      <Flex alignItems="center" height="100%" width="100%">
        <ListLoader marginLeft={8} rows={1} />
      </Flex>
      <Flex>
        <DockShareLink />
        <DockButton />
      </Flex>
    </>
  )
}
